import constants from '../../config/constants.ts'

const absenceCategories = {
  props: {
    absenceCategories: {
      type: Object,
      default: () => {}
    },
    absenceTypes: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    type: null,
    selectedAbsenceType: null,
    showAbsenceCategoryModal: false
  }),
  computed: {
    absenceType () {
      if (this.selectedAbsenceType) return [this.selectedAbsenceType]
      if (this.type) return [this.type]
      return [this.defaultAbsenceType]
    },
    defaultAbsenceType () {
      if (!Object.keys(this.absenceTypes).length) return
      const type = this.absenceTypes.types?.find(el => el.category === this.defaultTypeCategory)
      if (type) return type

      const defaultType = this.absenceTypes.types?.find(el => el.category === constants.classbook.absences.types.STANDARD_TYPE_ID)
      return defaultType || this.absenceTypes.types[0]
    }
  },
  methods: {
    selectDefaultType () {
      this.selectedAbsenceType = this.defaultAbsenceType?.category === this.defaultTypeCategory ? null : this.defaultAbsenceType
    },
    selectAbsenceType (absenceType) {
      this.selectedAbsenceType = absenceType
      this.showAbsenceCategoryModal = false
    }
  }
}

export default absenceCategories
